import { createReducer } from '@reduxjs/toolkit';
import { showConfirmationDialog, closeConfirmationDialog } from './actions';
import { DialogsState } from './types';

const initialState: DialogsState = {
  confirm: null,
};

const dialogsReducer = createReducer(initialState, (builder) => {
  /**
   * Show a OK/Cancel confirmation dialog
   */
  builder.addCase(showConfirmationDialog, (state, action) => {
    const confirm = action.payload;
    state.confirm = confirm;
  });
  /**
   * Hide OK/Cancel confirmation dialog
   */
  builder.addCase(closeConfirmationDialog, (state) => {
    state.confirm = null;
  });
});

export default dialogsReducer;
